import { render, staticRenderFns } from "./SendParentAppsend.vue?vue&type=template&id=8e2cd8bc&scoped=true"
import script from "./SendParentAppsend.vue?vue&type=script&lang=js"
export * from "./SendParentAppsend.vue?vue&type=script&lang=js"
import style0 from "./SendParentAppsend.vue?vue&type=style&index=0&id=8e2cd8bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2cd8bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e2cd8bc')) {
      api.createRecord('8e2cd8bc', component.options)
    } else {
      api.reload('8e2cd8bc', component.options)
    }
    module.hot.accept("./SendParentAppsend.vue?vue&type=template&id=8e2cd8bc&scoped=true", function () {
      api.rerender('8e2cd8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/birthdaymanagement/SendParentAppsend.vue"
export default component.exports